<template>
  <base-notification-item-contents-parts
    class="highlight-notification-item-contents-parts"
    :notification="notification"
    @handlerClickLink="$emit('handlerClickLink', notification)"
  >
    <highlight-card-parts
      class="highlight-notification-item-contents-parts__highlight"
      v-if="notification.extra"
      :highlightData="notification.extra"
    />
  </base-notification-item-contents-parts>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import BaseNotificationItemContentsParts from '@/components/NotificationPane/NotificationPane/parts/BaseNotificationItemContentsParts.vue'
import HighlightCardParts from '@/components/NotificationPane/NotificationPane/parts/HighlightCardParts.vue'

/**
 * Notification 詳細アイテム: TYPE = ハイライト用 コンポーネント
 */
export default defineComponent({
  name: 'HighlightNotificationItemContentsParts',
  components: {
    BaseNotificationItemContentsParts,
    HighlightCardParts,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.highlight-notification-item-contents-parts {
  &__highlight {
    margin-top: 12px;
    margin-bottom: 0;
  }
}
</style>
